import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faEye,
  faEyeSlash,
  faFilePdf,
  faCalendarDays,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCheck,
  faBars,
  faChevronDown,
  faChevronRight,
  faSpinner,
  faPhone,
  faCircleExclamation,
  faChevronLeft,
  faArrowLeft,
  faCalendar,
  faClock,
  faCamera,
  faXmark,
  faCopy,
  faShareNodes,
  faMagnifyingGlass,
  faLinkSlash,
  faWrench,
  faCalendarXmark,
  faCalendarPlus,
  faRotateRight,
  faBell,
  faCircleCheck,
  faCircleXmark,
  faVideo,
  faEnvelope,
  faLocationDot,
  faGear,
  faCreditCard,
  faTruck,
  faPaperPlane,
  faPiggyBank,
  faFileInvoiceDollar,
  faCircleHalfStroke,
  faBullseye,
  faUser,
  faCommentDots,
} from '@fortawesome/pro-solid-svg-icons';

export function setupFontAwesome(): void {
  // SINGLE call per CLAUDE.md constraint — never register icons outside this
  // function. New icons get added to this list only.
  library.add(
    faCheck, // Phase 1 — kept in case future code references it
    faBars, // AppShell mobile drawer hamburger trigger
    faChevronDown, // AppShell avatar dropdown caret
    faChevronRight, // AppShell sidebar collapse/expand toggle
    faSpinner, // BaseButton loading state spinner
    faPhone, // PublicShell branded strip phone number
    faCircleExclamation, // BaseInput error message icon
    // LoginView + CreateAccountView password show/hide toggle
    faEye,
    faEyeSlash,
    // Phase 4 icons (solid)
    faChevronLeft, // Wizard "Back", calendar prev-month button
    faArrowLeft, // BackToAppointmentsLink (D-31) on AppointmentDetailView
    faCalendar, // Calendar header decorator
    faClock, // Time slot icon (decorative)
    faCamera, // Photo upload zone visual
    faXmark, // Photo remove button, modal close
    faCopy, // Share link copy button
    faShareNodes, // Share tab icon
    faMagnifyingGlass, // Search field prefix in AppointmentsView Past zone
    faLinkSlash, // Magic link expired/invalid state icon
    faWrench, // Service category default icon
    faCalendarXmark, // AppointmentsView empty state (solid)
    faCalendarPlus, // AppointmentsView empty-state CTA leading icon; RebookCard "Schedule again" CTA glyph
    faRotateRight, // RebookCard (sketch 019 §11) circular badge glyph on the cancelled-state rebook surface
    faBell, // Slot summary card notification notice
    faCircleCheck, // Success check (ScheduleSuccessOverlay and terminal-state surfaces)
    faCircleXmark, // Cancelled-state muted icon
    faVideo, // VideoUpload tile icon (D-37, B1)
    faEnvelope, // ScheduleSuccessOverlay what's-next: text confirmation row
    faLocationDot, // ScheduleSuccessOverlay what's-next: real-time tracking row; en-route icon (04-12)
    faGear, // Manage appointment header icon (04-12 DETAIL-03)
    faCreditCard, // Balance-due invoice CTA leading icon
    faTruck, // StatusPill 'enroute' pill (sketch 022), referenced as ['fas','truck'] from STATUS_PILL_COPY
    faPaperPlane, // Phase 5.5: QuoteModal "Submit request" CTA glyph
    faPiggyBank, // Phase 5.5 Plan 08: FinancingOptionsPanel header icon
    faFileInvoiceDollar, // 5.2 D-21: StatusPill 'open' invoice pill (['fas','file-invoice-dollar'] from STATUS_PILL_COPY)
    faCircleHalfStroke, // 5.2 D-21: StatusPill 'partial' invoice pill (['fas','circle-half-stroke'] from STATUS_PILL_COPY)
    faBullseye, // 260618-esd: StatusPill 'current-draw' pill (['fas','bullseye'] from STATUS_PILL_COPY)
    faUser, // PODZ-1830 07.1-05: MediaLightboxBody upload-meta footer person icon (replaces the "Uploaded by" text prefix; sr-only label preserves a11y)
    faCommentDots, // PODZ-1830 07.1-05: grid-tile caption indicator badge (brand-primary circle w/ white speech-bubble on photo/video thumbnails whose media item has a non-empty caption)
    // Phase 4 icons (regular)
    faFilePdf, // Document download icon
    faCalendarDays, // Slot summary card date icon
  );
}

export { FontAwesomeIcon };
